import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { RootErrorBoundary } from './app/RootErrorBoundary'
import { installGlobalErrorHandlers } from '@mfox/shared/lib/errorReporting'
import { installHistoryGuard } from '@mfox/shared/lib/historyGuard'
import { initSentry } from '@mfox/shared/lib/sentry'
import { ThemeProvider } from '@mfox/shared/lib/ThemeProvider'

initSentry()
installGlobalErrorHandlers()
// Before the router mounts, so it runs ahead of the router's own Back/Forward handling.
installHistoryGuard()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <RootErrorBoundary>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </RootErrorBoundary>
  </StrictMode>,
)
